import { createSlice, Slice } from '@reduxjs/toolkit';
import {
  setActiveView,
  setActiveViewActionHandler,
  setSearchString,
  setSearchStringActionHandler,
} from './actions';
import { AccordionsSearchState, StateWithAccordionsSearchApp } from './types';

export const initialState: AccordionsSearchState = {
  searchString: '',
  activeView: '',
};

export const searchSlice: Slice<AccordionsSearchState> = createSlice({
  name: 'accordionsSearch',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(setSearchString, setSearchStringActionHandler)
      .addCase(setActiveView, setActiveViewActionHandler);
  },
});

export const selectAccordionsSearchState = <T extends StateWithAccordionsSearchApp>(state: T) =>
  state.accordionsSearchApp;
export const accordionsSearchReducer = searchSlice.reducer;
